import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import helpersNumbers from "../../../helpers/numbers";
import ReportDataFile from "./ReportData";
import constantsReportCampaign from "./constants/reportCampaign";

function BrowsersOSPieChart({ which_type_select, campaignID }) {
  const [data, setData] = useState([]);
  const [totalValue, setTotalValue] = useState(0);

  useEffect(() => {
    let browsersOS;
    if (
      which_type_select ==
      constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS
    ) {
      browsersOS = {
        iOS: 4000,
        Windows: 830000,
        Android: 250000,
        Linux: 5030,
      };
    } else {
      browsersOS = ReportDataFile.filter((report) => report.id == campaignID);
      browsersOS = browsersOS[0].browsers.browsers_OS;
    }
    let dataPieChar = [];
    let index = 1;
    let totalValue = 0;
    for (let key in browsersOS) {
      if (!browsersOS[key]) {
        continue;
      }
      dataPieChar.push({
        ID: uuidv4(),
        name: key,
        value: parseInt(browsersOS[key]),
        color: "#" + Math.floor(Math.random() * 16777215).toString(16),
        opacity: 1,
      });
      totalValue += parseInt(browsersOS[key]);
      index++;
    }

    setData(dataPieChar);
    setTotalValue(totalValue);
  }, []);

  const customizedTooltip = ({ payload, active }) => {
    if (!active) {
      return <></>;
    }
    if (payload == undefined) {
      return <></>;
    }

    if (payload[0] == undefined) {
      return <></>;
    }

    let label = payload[0].name;
    const partCircleHoverBackgroundColor = payload[0].payload.fill;
    return (
      <div className="card" id="box-details-pie-chart" dir="rtl">
        <div className="card-body p-3">
          <div className="text-center">{label}</div>
          <div className="my-2 hr-bottom-label"></div>
          <div className="d-flex pb-3">
            <span className="px-2">
              <i
                className="fa fa-circle"
                style={{ color: partCircleHoverBackgroundColor }}
              ></i>
            </span>
            <span className="pl-2">تعداد نمایش : </span>
            <span>{helpersNumbers.toPersianNum(payload[0].value)}</span>
          </div>
          <div className="d-flex  ">
            <span className="px-2">
              <i
                className="fa fa-circle"
                style={{ color: partCircleHoverBackgroundColor }}
              ></i>
            </span>
            <span className="pl-2">درصد : </span>
            <span>
              {helpersNumbers.toPersianNum(
                Math.floor((payload[0].value / totalValue) * 1000) / 10
              )}
              %
            </span>
          </div>
        </div>
      </div>
    );
  };

  const changeBgColorCellExpectCurrentCell = (currentCellID, changeOpacity) => {
    setData((prevState) => {
      return prevState.map((item) => {
        if (item.ID != currentCellID) {
          item.opacity = changeOpacity(item.opacity);
        }
        return item;
      });
    });
  };

  const mouseEnterHandle = (e, currentCellID) => {
    changeBgColorCellExpectCurrentCell(
      currentCellID,
      (opacity) => (opacity /= 2)
    );
  };
  const showPieChart = () => {
    return (
      <div style={{ margin: "0 auto" }}>
        <p className="text-center p-0">سیستم عامل</p>
        <ResponsiveContainer width={250} height={250}>
          <PieChart>
            <Pie
              data={data}
              labelLine={false}
              outerRadius={120}
              dataKey="value"
            >
              {data.map((entry, index) => {
                return (
                  <Cell
                    onMouseLeave={(e) => {
                      setData((prevState) => {
                        return prevState.map((item) => {
                          item.opacity = 1;
                          return item;
                        });
                      });
                    }}
                    style={{ opacity: entry.opacity }}
                    key={`cell-${index}`}
                    cursor="pointer"
                    fill={entry.color}
                  />
                );
              })}
            </Pie>
            <Tooltip content={customizedTooltip} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  };

  return <>{data.length > 0 && showPieChart()}</>;
}

const mapStateToProps = (state) => {
  return {
    which_type_select: state.reportCampaign.which_type_select,
    campaignID: state.reportCampaign.campaign_id_selected,
  };
};
export default connect(mapStateToProps, null)(BrowsersOSPieChart);
